import { Layout } from 'antd'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'
import Sidebar from '../sidebar/Sidebar'
import { useStore } from '../../../hooks'
import { TAB_SIZE } from '../../../helpers/constants'
import SidebarContent from '../sidebar/SidebarContent'
import UserProfile from '../sidebar/UserProfile'
import Images from '../../../common/Images'
import { orderManagerMeta } from '../../routes/metaData'
import { useEffect } from 'react'
import OrderManagerRouters from '../../routes/OrderManagerRouters'

const { Content } = Layout
const { Sider } = Layout

const LayoutOrderManager = observer((props: any) => {
   const match = useRouteMatch()
   const AuthStore = useStore('AuthStore')
   const isDesktop = AuthStore.width_screen >= TAB_SIZE
   const handleOpenSidebar = () => {
      AuthStore.action_openSidebar()
   }
   const handleToggleCollapsed = () => {
      AuthStore.action_toggleSidebarCollapsed()
   }
   const UserStore = useStore('UserStore')

   useEffect(() => {
      getListData()
   }, [])

   // Danh sach creator / designer cho bo loc va gan viec o man quan ly don
   const getListData = async () => {
      try {
         await UserStore.getCreators()
         await UserStore.getDesigners()
         await UserStore.getApprovers()
      } catch (error) {
         // console.log(error)
      } finally {
      }
   }
   return (
      <Layout className="gx-app-layout layout-admin">
         <Sider
            className={`gx-app-sidebar gx-layout-sider-dark`}
            trigger={null}
            collapsed={isDesktop && AuthStore.sidebarCollapsed}
            collapsedWidth={80}
            theme={'dark'}
            collapsible
         >
            {AuthStore.width_screen < TAB_SIZE ? (
               <Sidebar {...props} sideBarContent={orderManagerMeta} />
            ) : (
               <SidebarContent
                  {...props}
                  sideBarContent={orderManagerMeta}
                  collapsed={AuthStore.sidebarCollapsed}
                  onToggleCollapsed={handleToggleCollapsed}
               />
            )}
         </Sider>
         <Layout>
            {AuthStore.width_screen < TAB_SIZE && (
               <div className="gx-linebar header-mobile-container">
                  <div>
                     <i className="gx-icon-btn icon icon-menu" onClick={handleOpenSidebar} />
                  </div>

                  <div className="center-img-content2">
                     <img src={Images.logo_white} className="img-responsive" alt="Logo" />
                  </div>

                  <div>
                     <UserProfile />
                  </div>
               </div>
            )}
            <Content className={`gx-layout-content gx-main-content-wrapper`}>
               <OrderManagerRouters match={match} />
            </Content>
         </Layout>
      </Layout>
   )
})

export default LayoutOrderManager
